'use client';

import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';

import { cn } from '~/utils';

const Toggle = React.forwardRef<
    React.ElementRef<typeof TogglePrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root>
>(({ className, ...props }, ref) => (
    <TogglePrimitive.Root
        ref={ref}
        className={cn(
            'focus-visible:outline-hidden inline-flex h-8 select-none items-center justify-center rounded-3xl border border-blue-200 px-3 py-3 text-sm font-normal text-blue-400 ring-offset-background transition-[border-color,box-shadow,background-color,color,transform] hover:border-blue-300 hover:bg-blue-50/90 hover:text-secondary-400 hover:ring-2 hover:ring-secondary/25 hover:ring-offset-0 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:scale-[98%] active:opacity-80 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:border-secondary data-[state=on]:bg-secondary-50 data-[state=on]:font-medium data-[state=on]:text-secondary data-[state=on]:ring-0',
            className,
        )}
        {...props}
    />
));

Toggle.displayName = TogglePrimitive.Root.displayName;
export default Toggle;
